import i18n from "i18next";
import Backend from "i18next-xhr-backend";
import {initReactI18next} from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import commonKO from "./ko/common.json";
import loginKO from "./ko/login.json";
import shippingKO from "./ko/shipping.json";
import common from "./en/common.json";
import login from "./en/login.json";

const resources = {
  ko: {
    common: commonKO, login: loginKO, shipping: shippingKO,
  }, en: {
    common: common, login: login,
  },
};
i18n
.use(Backend)
.use(initReactI18next)
.use(LanguageDetector)
.init({
  resources, ns: [
    "box", "scan", "common", "login", "qr", "print", "pickup", "dispatch", "shipping",
  ], fallbackLng: "ko", lng: "ko", keySeparator: false, interpolation: {
    escapeValue: false,
  }, react: {
    useSuspense: false,
  },
});

export default i18n;
